"use client";

import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PORTALS } from ".constants/portals";
import {
  Box,
  Button,
  Icon,
  ModalContent,
  ModalFooter,
  ModalHeader,
  PortalModal,
  usePortalContext,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC, useEffect } from "react";
import { useCookies } from "react-cookie";

import { useGTMContext } from "@/providers";

export const TutorPosePortal: FC = () => {
  const t = useTranslations("PoseModal");
  const { currentPortal, closePortal } = usePortalContext();
  const { sendGTM } = useGTMContext();
  const [, setCookies] = useCookies([COOKIES.TUTOR_POSE_IS_READED]);

  useEffect(() => {
    if (currentPortal === PORTALS.TUTOR_POSE) {
      setCookies(COOKIES.TUTOR_POSE_IS_READED, 1, {
        maxAge: COOKIES_TIMES.YEAR_1, // примерно год в секундах
      });
    }
  }, [currentPortal, setCookies]);

  const handleClosePortal = () => {
    sendGTM({ event: GE.TUTOR_HD_BUY_COIN });
    closePortal();
  };

  return (
    <PortalModal portalId={PORTALS.TUTOR_POSE} variant="fixed">
      <ModalHeader>{t("title")}</ModalHeader>

      <ModalContent>
        <Box>
          <video
            loop
            autoPlay
            muted
            playsInline
            style={{
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.12)",
              width: "100%",
              aspectRatio: "398 / 270",
            }}
            poster="/images/tutor-video-pose-cover.webp"
          >
            <source
              src="/video/tutor-video-pose.mp4"
              type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
            />
          </video>
        </Box>
      </ModalContent>

      <ModalFooter>
        <Button
          startContent={<Icon icon="checkroom" />}
          color="primary"
          wide
          centerText
          onClick={handleClosePortal}
        >
          {t("textButton")}
        </Button>
      </ModalFooter>
    </PortalModal>
  );
};
